import script from "./ContactsBulkUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactsBulkUploader.vue?vue&type=script&setup=true&lang=js"

import "./ContactsBulkUploader.vue?vue&type=style&index=0&id=64931814&lang=css"

const __exports__ = script;

export default __exports__